<template>
<div>
    <h2>Welcome to the deepest why</h2>
    <p>
        check it out!
    </p>
</div>
</template>

<script>
export default {
    name:'welcome',
    data() {
        return {

        }
    },
}
</script>

<style scoped>

</style>